import ProvadersPage from "./Providers";

export default ProvadersPage;